@use "../../../../styles/text";

:host {
  @include text.text-body-xs;
  color: var(--color-text-base);
  display: block;
  margin-top: var(--spacing-xxs);
}

:host([alignment-selection="center"]) {
  text-align: center;
}
